/* eslint prettier/prettier: "off" */
/* eslint no-use-before-define: "off" */
/* eslint quotes: "off" */
/* eslint unicorn/prefer-code-point: "off" */

/**
 * DO NOT EDIT!!
 *
 * This is a copy and paste of a fully tested workflow from banking-web repo.
 * We are copying because we want the code to be the same for both dashboard and banking-web
 * when working with bb-debit Card.
 *
 * https://github.com/squareup/banking-web/blob/main/src/workflow/card-settings-v2/set-pin/index.ts
 */

import workflow from "@banking/ui/lib/workflow";
import { SetPinRequest, SetPinResponse } from "@square/dashboard-protos/models/squareup/bbdebit/cardmanagement";
/**
 * Set pin workflow to set/reset pin.
 */

const PIN_LENGTH = 4;
export let Screen = /*#__PURE__*/function (Screen) {
  Screen["SetPin"] = "SCREEN_SET_PIN";
  Screen["ConfirmPin"] = "SCREEN_CONFIRM_PIN";
  return Screen;
}({});
export let Error = /*#__PURE__*/function (Error) {
  Error["WeakPin"] = "ERROR_WEAK_PIN";
  Error["InvalidPinMatch"] = "ERROR_INVALID_PIN_MATCH";
  Error["GenericError"] = "ERROR_GENERIC";
  return Error;
}({});
export let ValueError = /*#__PURE__*/function (ValueError) {
  ValueError["InvalidLength"] = "VALUE_ERROR_INVALID_LENGTH";
  return ValueError;
}({});
export const INITIAL_STATE = {
  cardToken: "",
  confirmPin: "",
  confirmPinError: [],
  error: [],
  loading: false,
  isOpen: false,
  pin: "",
  pinError: []
};
export const createState = (overrides = {}) => ({
  ...INITIAL_STATE,
  ...overrides
});
export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["Done"] = "SET_PIN_DONE";
  ActionType["Initialize"] = "SET_PIN_INITIALIZE";
  ActionType["SetPin"] = "SET_PIN_SET_PIN";
  ActionType["SetPinReceived"] = "SET_PIN_RECEIVED";
  ActionType["SetPinRejected"] = "SET_PIN_REJECTED";
  ActionType["UserChangeConfirmPin"] = "SET_PIN_USER_CHANGE_CONFIRM_PIN";
  ActionType["UserChangePin"] = "SET_PIN_USER_CHANGE_PIN";
  ActionType["ToggleModal"] = "SET_PIN_TOGGLE_MODAL";
  return ActionType;
}({});
export const doneAction = () => ({
  type: ActionType.Done
});
export const initializeAction = cardToken => ({
  type: ActionType.Initialize,
  cardToken
});
export const setPinAction = () => ({
  type: ActionType.SetPin
});
export const setPinReceivedAction = response => ({
  type: ActionType.SetPinReceived,
  response
});
export const setPinRejectedAction = error => ({
  type: ActionType.SetPinRejected,
  error
});
export const userChangeConfirmPinAction = confirmPin => ({
  type: ActionType.UserChangeConfirmPin,
  confirmPin
});
export const userChangePinAction = pin => ({
  type: ActionType.UserChangePin,
  pin
});
export const toggleModalAction = isOpen => ({
  type: ActionType.ToggleModal,
  isOpen
});
function handleSetPin(context, state) {
  const {
    cardToken,
    pin,
    confirmPin
  } = state;
  const pinError = [];
  const confirmPinError = [];
  const error = [];
  if (pin.length !== PIN_LENGTH) {
    pinError.push(ValueError.InvalidLength);
  }
  if (confirmPin.length !== PIN_LENGTH) {
    confirmPinError.push(ValueError.InvalidLength);
  }
  if (pin.length === PIN_LENGTH && confirmPin.length === PIN_LENGTH && pin !== confirmPin) {
    error.push(Error.InvalidPinMatch);
  }
  const hasError = confirmPinError.length > 0 || error.length > 0 || pinError.length > 0;
  const work = () => {
    if (hasError) {
      return null;
    }
    return context.setPin(SetPinRequest.create({
      cardToken,
      pin
    })).then(setPinReceivedAction, setPinRejectedAction);
  };
  return [{
    ...state,
    confirmPinError,
    error,
    loading: !hasError,
    pinError
  }, work];
}
function handleSetPinReceived(_context, state, action) {
  const {
    errors
  } = action.response;
  if (errors.length === 0) {
    return [{
      ...state,
      isOpen: false,
      loading: false
    }, doneAction];
  }

  // Client will handle one error at a time, the first one.
  switch (errors[0]) {
    case SetPinResponse.SetPinError.SET_PIN_ERROR_INVALID_CARD_TOKEN:
      return [{
        ...state,
        confirmPinError: [ValueError.InvalidLength],
        pinError: [ValueError.InvalidLength],
        loading: false
      }, null];
    case SetPinResponse.SetPinError.SET_PIN_ERROR_WEAK_PIN:
      return [{
        ...state,
        error: [...state.error, Error.WeakPin],
        loading: false
      }, null];
    case SetPinResponse.SetPinError.SET_PIN_ERROR_UNAUTHORIZED:
    case SetPinResponse.SetPinError.SET_PIN_ERROR_DO_NOT_USE:
    default:
      return [{
        ...state,
        error: [...state.error, Error.GenericError],
        loading: false
      }, null];
  }
}
function handleSetPinRejected(context, state, action) {
  const {
    error
  } = action;
  context.sentry.captureException(`SetPin error - ${error}`);
  return [{
    ...state,
    error: [...state.error, Error.GenericError],
    loading: false
  }, null];
}
function handleUserChangeConfirmPin(state, action) {
  const {
    confirmPin
  } = action;
  return [{
    ...state,
    confirmPin,
    confirmPinError: []
  }, null];
}
function handleUserChangePin(state, action) {
  const {
    pin
  } = action;
  return [{
    ...state,
    pin,
    pinError: []
  }, null];
}
export const update = context => (state, action) => {
  switch (action.type) {
    case ActionType.Done:
      // noop action to watch for done
      return [state, null];
    case ActionType.Initialize:
      return [{
        ...INITIAL_STATE,
        cardToken: action.cardToken,
        isOpen: true
      }, null];
    case ActionType.SetPin:
      return handleSetPin(context, state);
    case ActionType.SetPinReceived:
      return handleSetPinReceived(context, state, action);
    case ActionType.SetPinRejected:
      return handleSetPinRejected(context, state, action);
    case ActionType.UserChangeConfirmPin:
      return handleUserChangeConfirmPin(state, action);
    case ActionType.UserChangePin:
      return handleUserChangePin(state, action);
    case ActionType.ToggleModal:
      return [{
        ...INITIAL_STATE,
        isOpen: action.isOpen
      }, null];
  }
};
const setPin = (seed, context) => {
  const w = workflow(update(context), seed);
  return {
    states: w.states,
    updates: w.updates,
    emit: w.emit
  };
};
export default setPin;